var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgOfflineCart = function SvgOfflineCart(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m4.758 12.774-1.48-9.607h-.903a.792.792 0 0 1 0-1.584h1.571a.79.79 0 0 1 .796.682l.26 1.693h6.081v1.584H5.246l.974 6.333h7.441l1.188-3.958H16.5l-1.493 4.977a.792.792 0 0 1-.758.564H5.554a.79.79 0 0 1-.797-.684Zm3.159 3.06a1.584 1.584 0 1 1-3.167 0 1.584 1.584 0 0 1 3.167 0Zm7.125 0a1.583 1.583 0 1 1-3.167 0 1.583 1.583 0 0 1 3.167 0Zm0-14.25a.792.792 0 0 1 .791.791v.792h.792a.792.792 0 0 1 0 1.583h-.792v.792a.792.792 0 0 1-1.583 0V4.75h-.792a.792.792 0 0 1 0-1.583h.792v-.792a.792.792 0 0 1 .792-.792Z",
    fill: "#4F4F4F"
  })));
};

export default SvgOfflineCart;